import script from "./_ItemEditReviewSingle.vue?vue&type=script&setup=true&lang=js"
export * from "./_ItemEditReviewSingle.vue?vue&type=script&setup=true&lang=js"

import "./_ItemEditReviewSingle.vue?vue&type=style&index=0&id=66a421ba&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66a421ba"]])

export default __exports__